import moment from "moment";

export class Versus {
  constructor({ animate, preview, update, animateOff }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.name = "Versus";
    this.scene = "Versus";
    this.data = [];
  }

  preview({ description, options }) {
    this.onAir = false;
    this.options = options;

    this.data = [];

    this.data.push({
      name: "Date",
      value: {
        text: moment(options.game?.date)?.format("DD/MM/YYYY") || "",
      },
    });

    this.data.push({
      name: "Group",
      value: {
        text: options?.group?.title || "",
      },
    });

    this.data.push({
      name: "Home Team Name",
      value: { text: options.game?.home_team?.name || "" },
    });

    this.data.push({
      name: "Home Team Short Name",
      value: { text: options.game?.home_team?.short_name || "" },
    });

    this.data.push({
      name: "Away Team Name",
      value: { text: options.game?.away_team?.name || "" },
    });
    this.data.push({
      name: "Away Team Short Name",
      value: { text: options.game?.away_team?.short_name || "" },
    });
    this.data.push({
      name: "Home Team Badge",
      value: {
        image: "${user}" + options.game?.home_team?.variables?.badge,
      },
    });

    this.data.push({
      name: "Home Team Secondary Badge",
      value: {
        image: "${user}" + options.game?.home_team?.variables?.alt_badge,
      },
    });

    this.data.push({
      name: "Away Team Badge",
      value: {
        image: "${user}" + options.game?.away_team?.variables?.badge,
      },
    });

    this.data.push({
      name: "Away Team Secondary Badge",
      value: {
        image: "${user}" + options.game?.away_team?.variables?.alt_badge,
      },
    });

    this.data.push({
      name: "Home Team Kit BG Colour",
      value: {
        colour:
          options.game.home_team?.variables?.[
            options.game?.home_team_kit + "_kit_bg"
          ] || "",
      },
    });
    this.data.push({
      name: "Home Team Kit Text Colour",
      value: {
        colour:
          options.game.home_team?.variables?.[
            options.game?.home_team_kit + "_kit_text"
          ] || "",
      },
    });
    this.data.push({
      name: "Away Team Kit BG Colour",
      value: {
        colour:
          options.game.away_team?.variables?.[
            options.game?.away_team_kit + "_kit_bg"
          ] || "",
      },
    });
    this.data.push({
      name: "Away Team Kit Text Colour",
      value: {
        colour:
          options.game.away_team?.variables?.[
            options.game?.away_team_kit + "_kit_text"
          ] || "",
      },
    });

    this.data.push({
      name: "Home Score",
      value: {
        text: options.game?.home_scorers?.length || 0,
      },
    });
    this.data.push({
      name: "Away Score",
      value: {
        text: options.game?.away_scorers?.length || 0,
      },
    });
    this.data.push({
      name: "Competition",
      value: { text: options.game?.competition?.name || "" },
    });

    this.data.push({
      name: "Competition Badge",
      value: { image: "${user}" + options.game?.competition?.badge || "" },
    });

    this.data.push({
      name: "Competition Colour",
      value: { colour: options.game?.competition?.colour || "" },
    });

    this.data.push({
      name: "Stadium",
      value: {
        text:
          options.game?.stadium?.name || options.game?.stadium?.opta_name || "",
      },
    });

    this.data.push({
      name: "Comm First Name 1",
      value: { text: options.game?.commentators?.[0]?.first_name || "" },
    });

    this.data.push({
      name: "Comm Last Name 1",
      value: { text: options.game?.commentators?.[0]?.last_name || "" },
    });

    this.data.push({
      name: "Comm Full Name 1",
      value: {
        text:
          (options.game?.commentators?.[0]?.first_name || "") +
          " " +
          (options.game?.commentators?.[0]?.last_name || ""),
      },
    });

    this.data.push({
      name: "Comm First Name 2",
      value: { text: options.game?.commentators?.[1]?.first_name || "" },
    });

    this.data.push({
      name: "Comm Last Name 2",
      value: { text: options.game?.commentators?.[1]?.last_name || "" },
    });

    this.data.push({
      name: "Comm Full Name 2",
      value: {
        text:
          (options.game?.commentators?.[1]?.first_name || "") +
          " " +
          (options.game?.commentators?.[1]?.last_name || ""),
      },
    });

    this.data.push({
      name: "Comm First Name 3",
      value: { text: options.game?.commentators?.[2]?.first_name || "" },
    });

    this.data.push({
      name: "Comm Last Name 3",
      value: { text: options.game?.commentators?.[2]?.last_name || "" },
    });

    this.data.push({
      name: "Comm Full Name 3",
      value: {
        text:
          (options.game?.commentators?.[2]?.first_name || "") +
          " " +
          (options.game?.commentators?.[2]?.last_name || ""),
      },
    });

    this.data.push({
      name: "Period",
      value: {
        text: options.period
          ? options.period?.kick_off === null
            ? options.period.number - 1
            : options.period.number
          : "",
      },
    });

    let officials = JSON.parse(
      JSON.stringify(options.game?.officials ?? [])
    )?.sort((a, b) => {
      if (a?.type === "Main") {
        return -1;
      }
      if (b?.type === "Main") {
        return 1;
      }
      return 0;
    });
    if (officials) {
      for (let x = 0; x < officials.length; x++) {
        let official = officials[x];
        let row = x + 1;

        this.data.push({
          name: "Official " + row + " First Name",
          value: {
            text: official?.official?.first_name,
          },
        });
        this.data.push({
          name: "Official " + row + " Last Name",
          value: {
            text: official?.official?.last_name,
          },
        });
        this.data.push({
          name: "Official " + row + " Full Name",
          value: {
            text:
              official?.official?.first_name +
              " " +
              official?.official?.last_name,
          },
        });
        this.data.push({
          name: "Official " + row + " Type",
          value: {
            text: official?.type
              .replace("Main", "Referee")
              .replace("Lineman 1", "Assistant Referee")
              .replace("Lineman 2", "Assistant Referee"),
          },
        });
      }
    }

    this.sendPreview(this.scene, 500, this.data, "IN", description);
  }

  animate({ options }) {
    this.onAir = true;
    this.sendAnimate(this.scene, this.data);
  }
  animateOff({ options }) {
    clearTimeout(this.to);
    this.onAir = false;
    this.sendAnimateOff(this.scene, []);
  }
}
